module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Mobile_10.59ebbeeb.jpg";